"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var pick_1 = __importDefault(require("lodash/pick"));
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var ContextMenu_1 = require("../ContextMenu");
var Keyboard = __importStar(require("../Keyboard"));
var renderer_1 = require("./renderer");
var Dropdown_1 = require("./renderer/Dropdown");
var Message = /** @class */ (function (_super) {
    __extends(Message, _super);
    function Message() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasError: false,
            showMore: false
        };
        _this.handleContextMenu = function (e) {
            (0, ContextMenu_1.showContextMenu)(e, _this.props);
        };
        return _this;
    }
    Message.getDerivedStateFromError = function (_error) {
        return { hasError: true };
    };
    Message.prototype.render_text = function (textMessage) {
        var _a = this.props.payload, text = _a.text, markdown = _a.markdown;
        var message = textMessage || text;
        return (react_1.default.createElement(renderer_1.Text, { markdown: markdown, text: message, intl: this.props.intl, maxLength: this.props.payload.trimLength, escapeHTML: this.props.store.escapeHTML, isBotMessage: this.props.isBotMessage }));
    };
    Message.prototype.render_quick_reply = function () {
        return this.render_text();
    };
    Message.prototype.render_login_prompt = function () {
        return (react_1.default.createElement(renderer_1.LoginPrompt, { isLastMessage: this.props.isLastGroup && this.props.isLastOfGroup, isBotMessage: this.props.isBotMessage, onSendData: this.props.onSendData }));
    };
    Message.prototype.render_carousel = function () {
        return (react_1.default.createElement(renderer_1.Carousel, { onSendData: this.props.onSendData, carousel: this.props.payload, escapeHTML: this.props.store.escapeHTML, isBotMessage: this.props.isBotMessage, intl: this.props.intl }));
    };
    Message.prototype.render_typing = function () {
        return (react_1.default.createElement("div", { className: 'bpw-typing-group' },
            react_1.default.createElement("div", { className: 'bpw-typing-bubble' }),
            react_1.default.createElement("div", { className: 'bpw-typing-bubble' }),
            react_1.default.createElement("div", { className: 'bpw-typing-bubble' })));
    };
    Message.prototype.render_audio = function () {
        return react_1.default.createElement(renderer_1.FileMessage, { file: this.props.payload, escapeTextHTML: this.props.store.escapeHTML });
    };
    Message.prototype.render_video = function () {
        return react_1.default.createElement(renderer_1.FileMessage, { file: this.props.payload, escapeTextHTML: this.props.store.escapeHTML });
    };
    Message.prototype.render_image = function () {
        return react_1.default.createElement(renderer_1.FileMessage, { file: this.props.payload, escapeTextHTML: this.props.store.escapeHTML });
    };
    Message.prototype.render_file = function () {
        return react_1.default.createElement(renderer_1.FileMessage, { file: this.props.payload, escapeTextHTML: this.props.store.escapeHTML });
    };
    Message.prototype.render_voice = function () {
        return (react_1.default.createElement(renderer_1.VoiceMessage, { file: this.props.payload, shouldPlay: this.props.shouldPlay, onAudioEnded: this.props.onAudioEnded }));
    };
    Message.prototype.render_custom = function () {
        var _a = this.props.payload || {}, _b = _a.module, module = _b === void 0 ? undefined : _b, _c = _a.component, component = _c === void 0 ? undefined : _c, _d = _a.wrapped, wrapped = _d === void 0 ? undefined : _d;
        if (!module || !component) {
            return this.render_unsupported();
        }
        // TODO: Remove eventually, it's for backward compatibility
        if (module === 'extensions' && component === 'Dropdown') {
            return this.render_dropdown();
        }
        var InjectedModuleView = this.props.store.bp.getModuleInjector();
        var messageDataProps = __assign({}, this.props.payload);
        delete messageDataProps.module;
        delete messageDataProps.component;
        var sanitizedProps = (0, pick_1.default)(this.props, [
            'messageId',
            'isLastGroup',
            'isLastOfGroup',
            'isBotMessage',
            'onSendData',
            'onFileUpload',
            'sentOn',
            'store',
            'className',
            'intl'
        ]);
        var props = __assign(__assign(__assign({}, sanitizedProps), messageDataProps), { keyboard: Keyboard, children: wrapped && react_1.default.createElement(Message, __assign({}, sanitizedProps, { keyboard: Keyboard, noBubble: true, payload: wrapped })) });
        return react_1.default.createElement(InjectedModuleView, { moduleName: module, componentName: component, lite: true, extraProps: props });
    };
    Message.prototype.render_session_reset = function () {
        return this.render_text(this.props.store.intl.formatMessage({ id: 'store.resetSessionMessage' }));
    };
    Message.prototype.render_visit = function () {
        return null;
    };
    Message.prototype.render_unsupported = function () {
        return '*Unsupported message type*';
    };
    Message.prototype.render_dropdown = function () {
        return react_1.default.createElement(Dropdown_1.Dropdown, __assign({}, this.props, this.props.payload, { escapeHTML: this.props.store.escapeHTML }));
    };
    Message.prototype.renderTimestamp = function () {
        return (react_1.default.createElement("span", { className: "bpw-message-timestamp" }, this.props.store.intl.formatTime(new Date(this.props.sentOn), { hour: 'numeric', minute: 'numeric' })));
    };
    Message.prototype.onMessageClicked = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.store.loadEventInDebugger(this.props.messageId, true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Message.prototype.componentDidMount = function () {
        this.props.isLastGroup &&
            this.props.isLastOfGroup &&
            this.props.store.composer.setLocked(this.props.payload.disableFreeText);
    };
    Message.prototype.render = function () {
        var _this = this;
        var _a, _b;
        if (this.state.hasError) {
            return '* Cannot display message *';
        }
        var type = this.props.type || (this.props.payload && this.props.payload.type);
        var wrappedType = this.props.payload && this.props.payload.wrapped && this.props.payload.wrapped.type;
        var renderer = (this["render_".concat(type)] || this.render_unsupported).bind(this);
        var wrappedClass = "bpw-bubble-".concat(wrappedType);
        var isEmulator = this.props.store.config.isEmulator;
        var rendered = renderer();
        if (rendered === null) {
            return null;
        }
        var additionalStyle = (this.props.payload && this.props.payload['web-style']) || {};
        if (this.props.noBubble || ((_b = (_a = this.props.payload) === null || _a === void 0 ? void 0 : _a.wrapped) === null || _b === void 0 ? void 0 : _b.noBubble)) {
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)(this.props.className, wrappedClass), style: additionalStyle }, rendered));
        }
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(this.props.className, wrappedClass, 'bpw-chat-bubble', "bpw-bubble-".concat(type), {
                'bpw-bubble-highlight': this.props.isHighlighted,
                'bpw-msg-hovering': isEmulator
            }), "data-from": this.props.fromLabel, onClick: function () { return _this.onMessageClicked(); }, tabIndex: -1, style: additionalStyle },
            react_1.default.createElement("div", { tabIndex: -1, className: "bpw-chat-bubble-content", onContextMenu: type !== 'session_reset' ? this.handleContextMenu : function () { } },
                react_1.default.createElement("span", { className: "sr-only" }, this.props.store.intl.formatMessage({
                    id: this.props.isBotMessage ? 'message.botSaid' : 'message.iSaid',
                    defaultMessage: this.props.isBotMessage ? 'Virtual assistant said : ' : 'I said : '
                })),
                rendered,
                this.props.store.config.showTimestamp && this.renderTimestamp()),
            this.props.inlineFeedback));
    };
    return Message;
}(react_1.Component));
exports.default = (0, mobx_react_1.inject)(function (_a) {
    var store = _a.store;
    return ({
        intl: store.intl
    });
})((0, react_intl_1.injectIntl)((0, mobx_react_1.observer)(Message)));
